export const apiUrl = "https://housemaid.easymedia.agency";
